export const STRIPE_API_URL = `https://${process.env.REACT_APP_STRIPE_API_URL}`;
export const REST_ADS_API_URL = `https://${process.env.REACT_APP_TEMPO_REST_ADS_API_URL}`;
export const REST_EMAIL_API_URL = `https://${process.env.REACT_APP_TEMPO_REST_EMAIL_API_URL}`;
export const GET_ACTIVE_CAMPAIGNS = `https://${process.env.REACT_APP_TEMPO_REST_ADS_API_URL}/activeCampaigns`;
